import store from "@/store"

export default {
    get account() {
        return store.state.account.data
    },

    set account(account) {
        store.commit("account/update", account)
    },
}
